export class GraphResult {
    constructor(graph, failed) {
        this.graph = graph;
        this.failed = failed;
    }
    static failed() {
        return GraphResult.failedResult;
    }
    static success(graph) {
        return new GraphResult(graph);
    }
}
GraphResult.failedResult = new GraphResult(null, true);
